/** Settings › Notifications' three tabs (the device notifications round, 2026-11-01; brief docs/briefs/device-notifications-round.md rule 1,
 *  the red team's findings 14 and 15): Device, Email and Quiet times, in the address as `?tab=` (the first shown tab is the page without one).
 *  The Device tab goes only when the server has no key pair (`deviceTabShown` in `pushCard.ts`); then Email is first and `?tab=device` opens
 *  it. Pure, like `aiTabs.ts`. */
export type NotifyTabId = "device" | "email" | "quiet";
export type NotifyTab = { id: NotifyTabId; label: string };
export const NOTIFY_TABS: readonly NotifyTab[] = [{ id: "device", label: "Device" }, { id: "email", label: "Email" }, { id: "quiet", label: "Quiet times" }];

/** the tabs shown: all three, or Email and Quiet times without the Device tab */
export const notifyTabsFor = (deviceShown: boolean): NotifyTab[] => NOTIFY_TABS.filter((t) => deviceShown || t.id !== "device");

/** the tab an address opens: the asked one when it is shown, else the first shown tab (an old or typed link never opens an empty page) */
export const resolveNotifyTab = (asked: string | null, tabs: readonly { id: string }[]): NotifyTabId =>
  (tabs.find((t) => t.id === asked)?.id ?? tabs[0]?.id ?? "email") as NotifyTabId;

/** the `?tab=` value for a tab: none for the first shown tab */
export const notifyTabParam = (id: string, tabs: readonly { id: string }[]): string | null => (tabs[0]?.id === id ? null : id);
